<template>
  <Container>
    <h1>Scores à valider</h1>
      <Notification
        v-if="displayTeamsNotification"
        message="Pour débuter le tournoi, il faut compléter les équipes"
        linkPath="/teams"
        linkLabel="Compléter les équipes"
      />

      <div class="matchToValidate" v-for="match in matchesToValidate" v-bind:key="match.id">
        <div>
          <Match :match="match"/>
        </div>
        <div>
          <div class="buttonBox">
            <a class="validateButton" v-on:click="validateScore(match)">Score OK</a>
          </div>
        </div>
      </div>
      
    
  </Container>
</template>

<script>
// @ is an alias to /src
import Notification from "@/components/Notification.vue";
import Match from "@/components/Match.vue";
import Container from "@/components/Container.vue";
import axios from "axios";

export default {
  name: "home",
  components: {
    Notification,
    Match,
    Container
  },
  computed: {
    tournament(){
      return this.$store.state.tournament;
    },
    displayTeamsNotification() {
      var teams = this.$store.state.teams;
      if (teams){
        return teams.length === 0;
      }
      return true;
    },
    matches(){
      return (this.$store.state.matches) ? this.$store.state.matches : [];
    },
    matchesToValidate(){
      return this.matches.filter(match => match.score && match.validated === false).reverse();
    }
  },
  methods: {
    validateScore(match){
      axios.post("/matches/" + match.id + "/validate").then(response => {
        this.$snack.success('Score validé')
      });
    }
  }
};
</script>
<style scoped>
.matchToValidate{
  display: grid;
  grid-template-columns: 5fr 1fr;
}
.buttonBox{
  width: 80%;
  margin: auto;
  height: 100%;
}
.validateButton{
  padding: 10px 20px;
  box-shadow: 0.1em 0.3em 0.4em #bbb;
  cursor: pointer;
  font-size: larger;
  display: inline-block;
  width: 80%;
  border-radius: 5px;
  background-color: #2e7d32;
  color: whitesmoke;
  text-align: center;
  margin-top: 60px;
}
.validateIcon{
  padding-top: 5px;
}
</style>
